import { StyledButton } from "@insite/mobius/Clickable";
import { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide/link";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const dataTable = (): { defaultProps?: DataTablePresentationProps } => ({
    defaultProps: {
        sortIconProps: {
            size: 22,
        },
        css: css`
            text-align: left;
            border-spacing: 0;
            border-collapse: collapse;
            overflow-x: auto;
            white-space: nowrap;
            display: table;
            line-height: normal;

            /* width */
            ::-webkit-scrollbar {
                width: 5px;
            }

            /* Track */
            ::-webkit-scrollbar-track {
                background: #eff1f2;
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
                background: #015583;
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
                background: #015583;
            }

            thead,
            thead th,
            thead tr th {
                padding: 12px 25.6px 10px 15px;
                background-color: ${getColor(colorStrings.commonGlobalBlack)};
                color: ${getColor(colorStrings.commonGlobalWhite)};
                font-size: 18px;
                font-weight: 700;
                border-width: 0 1px 0 0;
                border-style: solid;
                border-color: ${getColor(colorStrings.commonGlobalWhite)};

                ${TypographyStyle} {
                    font-size: 16px;
                    font-weight: 700;
                }
            }

            /* stylelint-disable-next-line */
            thead th ${StyledButton}, thead th ${IconWrapper} {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }

            tr td,
            tbody tr,
            tbody tr td {
                padding: 11px 23px 9px 13px;
                color: ${getColor(colorStrings.commonGlobalBlack)};
                font-size: 16px;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                border-width: 0 1px 0 0;
                border-style: solid;
                border-color: ${getColor(colorStrings.commonGlobalWhite)};

                ${TypographyStyle} {
                    font-size: 16px;
                }

                a {
                    ${commonLinkStyles}
                    ${customLinkHoverStyles}
                }
            }

            tr:nth-child(even) {
                background: transparent;
            }

            tr:nth-child(odd) {
                background: ${getColor(colorStrings.commonGlobalGray04)};
            }
        `,
    },
});
